export const FETCH_ESTABLISHMENTS_ACTION =
  '@fmc/point-management/common/FETCH_ESTABLISHMENTS_ACTION';
export const FETCH_ESTABLISHMENTS_FAILURE =
  '@fmc/point-management/common/FETCH_ESTABLISHMENTS_FAILURE';
export const FETCH_ESTABLISHMENTS_SUCCESS =
  '@fmc/point-management/common/FETCH_ESTABLISHMENTS_SUCCESS';
